"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@emotion/core");
var _styled = _interopRequireDefault(require("@emotion/styled"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var spin = (0, _core.keyframes)({
  "0%": {
    transform: "rotate(0deg)"
  },
  "100%": {
    transform: "rotate(360deg)"
  }
});
var Spinner = _styled["default"].div({
  border: "6px solid #f3f3f3",
  borderTop: "6px solid rgba(85, 85, 85, 0.2)",
  borderRadius: "50%",
  width: "40px",
  height: "40px",
  animation: "".concat(spin, " 2s linear infinite")
});

// export const Spinner = (props) => <SpinnerDiv className={styles.Spinner} />
var _default = Spinner;
exports["default"] = _default;